// @flow
type UrlParameters = {| path: string, params?: any |};
type MapRouteToUrl = (page: string, params: any) => UrlParameters;
// TODO: Route object should handle more than just pages: See https://jira.tamg.io/browse/WP-1544
// eslint-disable-next-line import/prefer-default-export
export const buildTripModal = (mapper: MapRouteToUrl): MapRouteToUrl => (
  page: string,
  { tripModal, ...params },
) => {
  if (typeof tripModal === 'object') {
    const { title, id, scrollToReference } = tripModal;
    if (id) {
      let path = `Trips/${id}`;
      if (title) {
        path += `/${encodeURIComponent(title)}`;
      }
      if (scrollToReference && scrollToReference.type && scrollToReference.id) {
        path += `?type=${scrollToReference.type}&id${scrollToReference.id}`;
      }
      return { path };
    }
  }
  return mapper(page, params);
};
